export default __webpack_public_path__ + "static/smile-36f5d2406169a641f53c3913619fb7f5.png";